export const strong = (chunks) => <strong>{chunks}</strong>
export const p = (chunks) => <p>{chunks}</p>
export const i = (chunks) => <i>{chunks}</i>
export const em = (chunks) => <em>{chunks}</em>
export const linebreak = <br />
export const nbsp = '\u00A0'
